import React from 'react';
import PropTypes from 'prop-types';
import { hasValue } from '../../../general/js/general-helpers';
import { DEFAULT_SOLD_OUT_LABEL } from './constants';

export default class CheckboxPanel extends React.Component {
    renderAdditional() {
        return this.props.additional ? this.props.additional : null;
    }

    renderButton() {
        if (this.props.isDisabled) {
            return null;
        }

        if (this.props.button) {
            return this.props.button;
        }

        const selectBtnText = this.props.isSelected ? 'Remove' : 'Add';
        let selectBtnLabel = '';

        if (this.props.isSelected) {
            selectBtnLabel = 'Remove from basket';
        } else {
            selectBtnLabel = 'Add to basket';
        }

        const noSpacesTitle = this.props.title.replaceAll(' ', '-');

        return (
            <button
                className="product-panel__button button button--secondary"
                type="button"
                id={`${this.props.isSelected ? 'removeFromBasket-' : 'addToBasket-'}${noSpacesTitle}`}
                onClick={this.props.onClick}
                aria-label={selectBtnLabel}>
                <span className="button-content">
                    <span>{selectBtnText}</span>
                </span>
            </button>
        );
    }

    render() {
        const soldOutLabel = hasValue(this.props.soldOutLabel) ? this.props.soldOutLabel : DEFAULT_SOLD_OUT_LABEL;

        return (
            <div
                className={`product-panel ${this.props.cssClasses} ${this.props.isSelected ? 'is-selected' : ''} ${this.props.isDisabled ? 'is-disabled' : ''}`}
                data-sold-out-label={soldOutLabel}>
                <div className="product-panel__main">
                    <div className="product-panel__info">
                        <h4 className="product-panel__heading">
                            <span>{this.props.title}</span>
                            {
                                this.props.bracketsText ?
                                    <span
                                        className="product-panel__period">{this.props.bracketsText}</span> : ''
                            }
                        </h4>
                        <div className="product-panel__summary">{this.props.text}</div>
                    </div>
                    {this.renderAdditional()}
                    {this.renderButton()}
                </div>
                <svg className="product-panel__icon-tick icon" width="13" height="11" focusable="false">
                    <use xlinkHref="#icon-tick"></use>
                </svg>
            </div>
        );
    }
}

CheckboxPanel.defaultProps = {
    cssClasses: '',
};

CheckboxPanel.propTypes = {
    title: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    text: PropTypes.string,
    bracketsText: PropTypes.string,
    additional: PropTypes.element,
    button: PropTypes.element,
    cssClasses: PropTypes.string,
    onClick: PropTypes.func,
};
